<ng-container *ngIf="remoteFormData != undefined">
    <ubs-ofbiz-list 
        [fieldOptions]="fieldOptions" 
        [listOptions]="listOptions" 
        title="title" 
        [state]="state$" 
        (overViewSelected)="showOverview($event)" 
        (editSelected)="showEditDialog($event)" 
        [columnFields]="columnFields"
        [columnFieldTitles]="columnFieldTitles"
        [remoteFormData]="remoteFormData" 
        (hyperlinkSelected)="handleHyperLinkSelected($event)"
        (listSuccessNotify) = "handleListSucessNotify($event)"
        [isLookup]="isLookup"
        [cardMode]="cardMode">
    </ubs-ofbiz-list>
</ng-container>
